// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorPage_wrapper__IxrWR","error":"ErrorPage_error__-sJl-"};